const $$splitErrorComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/account/file.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/account/file.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { FileFilterParamSchema } from '@apps/main/features/user/pages/account/file-page';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/user/account/file')({
  validateSearch: FileFilterParamSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});